/**
 * Gate around the internal team pages. Redirects to /login if the
 * user isn't signed in, and to /portal if they're signed in as a
 * CLIENT (clients never see the team-facing app).
 */
import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';
import { currentHandoff } from '@/lib/host-split';
import { AccountHandoff } from '@/components/HostHandoff';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user?.role === 'CLIENT') {
    return <Navigate to="/portal" replace />;
  }
  // A-Roll SaaS members never see KG chrome; their world is /aroll
  // (the API fences them off the CRM anyway, this avoids a dead shell).
  if (user?.tenantId) {
    // PictureUp on its own host: sign them in there instead of opening
    // the PictureUp shell on the CRM host.
    const handoff = currentHandoff(user);
    if (handoff) return <AccountHandoff handoff={handoff} />;
    return <Navigate to="/aroll" replace />;
  }
  return <>{children}</>;
}
